<template>
  <div class="one-main">
    <img src="@/assets/image/one_img/gsjs1.png" class="main_img"/>
    <img src="@/assets/image/one_img/logo1.png" class="main_img1"/>
    <div class="top_text t_one wow animate__fadeInDown" >信息化原创性</div>
    <div class="top_text t_two wow animate__fadeInDown" >软件技术研发企业 </div>
    <div class="top_text t_three wow animate__fadeInDown" >数智展览展示一站式解决方案 </div>
    <div class="top_text t_four wow animate__fadeInDown" >综合服务商</div>
    <!-- 公司概述 -->
    <div class="one-main-o wh-img goto1" @click="summaryClick()">
      <img src="@/assets/image/one_img/gk1.png" class="one_img "/>
      <img src="@/assets/image/one_img/gk4.png" class="one_img go"/>
      <img src="@/assets/image/one_img/gk3.png" class="one_img to"/>
      <img src="@/assets/image/one_img/bg3.png" class="one_img "/>
      <img src="@/assets/image/one_img/text1.png" class="one_text"/>
    </div>
    <!-- 主营事业 -->
    <div class="one-main-t wh-img goto2" @click="Mainbusiness()">
      <img src="@/assets/image/one_img/zk1.png" class="one_img "/>
      <img src="@/assets/image/one_img/zk4.png" class="one_img go"/>
      <img src="@/assets/image/one_img/zk3.png" class="one_img to"/>
      <img src="@/assets/image/one_img/bg4.png" class="one_img "/>
      <img src="@/assets/image/one_img/text4.png" class="one_text"/>
    </div>
    <!-- 经典案例 -->
    <div class="one-main-th wh-img goto3" @click="ClassicCases()">
      <img src="@/assets/image/one_img/jk1.png" class="one_img "/>
      <img src="@/assets/image/one_img/jk4.png" class="one_img go"/>
      <img src="@/assets/image/one_img/jk3.png" class="one_img to"/>
      <img src="@/assets/image/one_img/bg2.png" class="one_img "/>
      <img src="@/assets/image/one_img/text3.png" class="one_text"/>
    </div>
    <!-- 合作伙伴 -->
    <div class="one-main-f wh-img goto4" @click="Partners()">
      <img src="@/assets/image/one_img/hk1.png" class="one_img "/>
      <img src="@/assets/image/one_img/hk4.png" class="one_img go"/>
      <img src="@/assets/image/one_img/hk3.png" class="one_img to"/>
      <img src="@/assets/image/one_img/bg1.png" class="one_img "/>
      <img src="@/assets/image/one_img/text2.png" class="one_text"/>
    </div>
  </div>
</template>

<script setup>
  import { useRouter } from 'vue-router'
  import { ref , onMounted} from 'vue'
  const router = useRouter()
  const summaryClick = () => {
    router.push({path:'/summary',query:{index1:1}})
  }
  const Mainbusiness = () =>{
    router.push('/mainbusiness')
  }
  const ClassicCases = () =>{
    router.push('/ClassicCases')
  }
  const Partners = ()=>{
    router.push('/Partners')
  }
  const emit = defineEmits([ "doSth" ]);
  const doSth = () => {
    emit('doSth');
  }
  const autioClick = () =>{
    emit('doSth');
  }
  onMounted(() => {
    doSth();
  });
</script>

<style scoped>
@media (min-width:900px) {

}
@media only screen and (max-width: 900px) {
.one-main{
  width: 100%;
  overflow-y: scroll;
  position: relative;
}
.main_img{
  width: 100%;
  height: auto;
}
.main_img1{
  width: 60%;
  height: auto;
  position: absolute;
  top: 1rem;
  left: 0.5rem;
}
.top_text{
  color: #00f0ff;
  z-index: 2;
}
.t_one{
  position: absolute;
  top: 2.4rem;
  left: 0.5rem;
  font-size: 0.45rem;
}
.t_two{
  position: absolute;
  top: 3rem;
  left: 0.5rem;
  font-weight: 700;
  font-size: 0.52rem;
}
.t_three{
  position: absolute;
  top: 4.1rem;
  left: 0.5rem;
  font-size: 0.45rem;
}
.t_four{
  position: absolute;
  top: 4.7rem;
  left: 0.5rem;
  font-size: 0.52rem;
  font-weight: 700;
}
.wh-img{
  width: 2rem;
  height: 2rem;
}
.one-main-o{
  position: absolute;
  top: 5.6rem;
  left: 7.5rem;
  z-index: 2;
}
.one-main-t{
  position: absolute;
  top: 8.5rem;
  left: 6.4rem;
  z-index: 2;
}
.one-main-th{
  position: absolute;
  top: 10.5rem;
  left: 3.7rem;
  z-index: 2;
}
.one-main-f{
  position: absolute;
  top: 11.7rem;
  left: 0.7rem;
  z-index: 2;
}
.one_img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0rem;
  left: 0rem;
}
.one_text{
  width: 1rem;
  height: 1rem;
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
}

/* 旋转动画 */
  .go {
    /* transform: rotate(180deg); */
    transition: all ;
    animation-name: animtran;
    animation-duration: 5s;
    /*动画持续时间*/
    animation-fill-mode: forwards;
    /*动画填充模式，forwards作用是将动画的样式停留在最后一个 */
    animation-direction: reverse;
    /*规定是否应该轮流反向播放动画。*/
    animation-iteration-count: infinite;
    /*规定动画的速度曲线。*/
    animation-timing-function: cubic-bezier(1, 1, 1, 1);
    /*速度 */
  }
  @keyframes animtran {
      0% {
          transform: rotate(0deg);
      }

      100% {
          transform: rotate(360deg);
      }
  }
  .to {
    /* transform: rotate(180deg); */
    transition: all ;
    animation-name: animtran;
    animation-duration: 5s;
    /*动画持续时间*/
    animation-fill-mode: forwards;
    /*动画填充模式，forwards作用是将动画的样式停留在最后一个 */
    animation-direction: normal;
    /*规定是否应该轮流反向播放动画。*/
    animation-iteration-count: infinite;
    /*规定动画的速度曲线。*/
    animation-timing-function: cubic-bezier(1, 1, 1, 1);
    /*速度 */
  }
  @keyframes animtran {
      0% {
          transform: rotate(0deg);
      }
      100% {
          transform: rotate(360deg);
      }
  }

  .goto1 {
    /* transform: rotate(180deg); */
    transition: all ;
    animation-name: animtran1;
    animation-duration: 1.5s;
    /*动画持续时间*/
    /* animation-fill-mode: forwards; */
    /*动画填充模式，forwards作用是将动画的样式停留在最后一个 */
    animation-direction: reverse;
    /*规定是否应该轮流反向播放动画。*/
    /* animation-iteration-count: infinite; */
    /*规定动画的速度曲线。*/
    /* animation-timing-function: cubic-bezier(1, 1, 1, 1); */
    /*速度 */
  }
  @keyframes animtran1 {
      0% {
        position: absolute;
        top: 5.6rem;
        left: 7.5rem;
        transform-origin: 50% 100%;
        transform: rotate(0deg) translateX(270);
      }
      100% {
        position: absolute;
        top: 11.7rem;
        left: -3rem;
        transform-origin: 50% 100%;
        transform: rotate(180deg) translateX(0px);
      }
  }
  .goto2 {
    /* transform: rotate(180deg); */
    transition: all ;
    animation-name: animtran2;
    animation-duration: 2.5s;
    /*动画持续时间*/
    /* animation-fill-mode: forwards; */
    /*动画填充模式，forwards作用是将动画的样式停留在最后一个 */
    animation-direction: reverse;
    /*规定是否应该轮流反向播放动画。*/
    /* animation-iteration-count: infinite; */
    /*规定动画的速度曲线。*/
    /* animation-timing-function: cubic-bezier(1, 1, 1, 1); */
    /*速度 */
  }
  @keyframes animtran2 {
      0% {
        position: absolute;
        top: 8.5rem;
        left: 6.4rem;
        transform-origin: 50% 100%;
        transform: rotate(90deg) translateX(200);
      }
      100% {
        position: absolute;
        top: 11.7rem;
        left: -3rem;
        transform-origin: 50% 100%;
        transform: rotate(270deg) translateX(0px);
      }
  }
  .goto3 {
    /* transform: rotate(180deg); */
    transition: all ;
    animation-name: animtran3;
    animation-duration: 3s;
    /*动画持续时间*/
    /* animation-fill-mode: forwards; */
    /*动画填充模式，forwards作用是将动画的样式停留在最后一个 */
    animation-direction: reverse;
    /*规定是否应该轮流反向播放动画。*/
    /* animation-iteration-count: infinite; */
    /*规定动画的速度曲线。*/
    /* animation-timing-function: cubic-bezier(1, 1, 1, 1); */
    /*速度 */
  }
  @keyframes animtran3 {
      0% {
        position: absolute;
        top: 10.5rem;
        left: 3.7rem;
        transform-origin: 50% 100%;
        transform: rotate(90deg) translateX(200);
      }
      100% {
        position: absolute;
        top: 11.7rem;
        left: -3rem;
        transform-origin: 50% 100%;
        transform: rotate(270deg) translateX(0px);
      }
  }
  .goto4 {
    /* transform: rotate(180deg); */
    transition: all ;
    animation-name: animtran4;
    animation-duration: 3.5s;
    /*动画持续时间*/
    /* animation-fill-mode: forwards; */
    /*动画填充模式，forwards作用是将动画的样式停留在最后一个 */
    animation-direction: reverse;
    /*规定是否应该轮流反向播放动画。*/
    /* animation-iteration-count: infinite; */
    /*规定动画的速度曲线。*/
    /* animation-timing-function: cubic-bezier(1, 1, 1, 1); */
    /*速度 */
  }
  @keyframes animtran4 {
      0% {
        position: absolute;
        top: 11.7rem;
        left: 0.7rem;
        transform-origin: 50% 100%;
        transform: rotate(90deg) translateX(100);
      }
      100% {
        position: absolute;
        top: 11.7rem;
        left: -3rem;
        transform-origin: 50% 100%;
        transform: rotate(270deg) translateX(0px);
      }
  }
  ::-webkit-scrollbar {  /* 隐藏滚动条 */
    display: none;
  }
}

</style>
